//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
import { find } from 'lodash'
import PurchaseTokenDialog from '@/components/PurchaseTokenDialog.vue'

export default {
  name: 'ProjectTokenCard',
  components: {
    PurchaseTokenDialog,
  },
  props: {
    project: {
      type: Object,
      default: null,
    },
    token: {
      type: Object,
      default: null,
    },
    allowList: {
      type: Boolean,
      default: false,
    },
    purchased: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    loading: false,
    purchaseDialog: false,
    agree: false,
    confirmation: false,
    selected: false,
    listPrice: 0,
  }),
  computed: {
    assetLink() {
      return `/assets/${
        this.project ? this.project.slug : this.token.project_id
      }/${this.token.token_id}`
    },
    ask() {
      const ask = find(this.token.Trades, (t) => t.trade_type === 'ask')
      if (ask) return ask
      return null
    },
    askPrice() {
      if (this.ask) {
        const price = this.ask.price / 1000000

        return Number.isInteger(price) ? price : price.toFixed(3)
      }
      return null
    },
    userAddress() {
      return this.$store.getters.userAddress
    },
    revealTime() {
      const rt = moment(this.token.reveal_time)
      if (moment().isAfter(rt)) {
        return 'Reveal in progress...'
      }
      return 'Revealing ' + rt.fromNow()
    },
  },
  watch: {
    purchaseDialog(v) {
      if (v === false && this.confirmation === true) {
        this.purchased(this.token)
      }
      if (v) {
        this.confirmation = false
      }
    },
    selected(v) {
      this.$emit('selected', { token: this.token, selected: v })
      if (v && parseFloat(this.listPrice) === 0) {
        this.listPrice = '1'
      }
    },
    listPrice(v) {
      this.selected = parseFloat(v) > 0
      this.$emit('priceChange', { token: this.token, listPrice: parseFloat(v) })
    },
    allowList(v) {
      if (v) {
        this.selected = false
      }
    },
  },
  methods: {
    openHelpWallet() {
      this.$refs.helpWalletDialog.handleOpen()
      this.purchaseDialog = false
    },
    async cancelListing() {
      try {
        this.confirmation = false
        this.loading = true
        const market = await this.$globals.tezos.wallet.at(
          this.ask.market_address
        )
        const op = await market.methods.cancel_ask(this.ask.trade_id).send()
        await op.confirmation(1)
        this.loading = false
        this.purchased(this.token)
        this.$store.dispatch('addSnackbar', {
          text: `Your listing has been canceled.`,
        })
      } catch (e) {
        this.loading = false
        this.$store.dispatch('addSnackbar', {
          text: `Failed to cancel listing. Please try again later. (You can try disconnecting and reconnecting your wallet.)`,
          type: 'error',
        })
        if (e?.message && e?.message?.includes('ABORTED_ERROR')) {
          this.disconnectWallet()
        }
      }
    },
    async disconnectWallet() {
      await this.$globals.disconnectWallet()
      this.$store.commit('INIT_USER_WALLET', { wallet: null, alias: null })
    },
    // async buyToken() {
    //   try {
    //     this.confirmation = false
    //     this.loading = true
    //     const opts = {}
    //     opts.amount = this.ask.price
    //     opts.mutez = true
    //     const market = await this.$globals.tezos.wallet.at(
    //       this.ask.market_address
    //     )
    //     const op = await market.methods
    //       .fulfill_ask(1, this.ask.trade_id)
    //       .send(opts)
    //     await op.confirmation(1)
    //     this.loading = false
    //     this.confirmation = true
    //     if (!this.purchaseDialog) {
    //       this.$store.dispatch('addSnackbar', {
    //         text: `You successfully purchased ${this.token.name} for ${this.askPrice} XTZ (Tezos).`,
    //       })
    //       this.purchased(this.token)
    //     }
    //   } catch (e) {
    //     this.loading = false
    //     console.error('Unable to purchase token', e)
    //   }
    // },
    // async connectWallet() {
    //   this.loading = true

    //   try {
    //     const userAddress = await this.$globals.connectWallet()
    //     this.$store.commit('INIT_USER_WALLET', {wallet: userAddress})
    //     this.$store.dispatch('logTerms', { wallet: userAddress, version:this.$config.termsVersion })
    //     this.$store.dispatch('loadBalance', userAddress)
    //     // await axios({
    //     //   method: 'post',
    //     //   url: '/api/termsLog',
    //     //   data: {
    //     //     userAddress: this.state.userAddress,
    //     //     version: this.state.termsVersion,
    //     //     application: 'PixelDebates',
    //     //   },
    //     // })
    //     this.loading = false
    //   } catch (e) {
    //     console.error('Unable to connect wallet', e)
    //     this.loading = false
    //   }
    // },
  },
}
